<template>
    <div class="login_bg">
        <div class="login_adv">
            <div class="login_adv__title">
                <h4>高性能 / 精致 / 优雅</h4>
                <p>基于Vue3 + Element-Plus + Webman 的中后台前端解决方案。</p>
                <div>
					<span>
                        <ui-icon type="logo-vue" size="40" />
					</span>
                    <span>
						<el-icon class="add"><el-icon-plus /></el-icon>
					</span>
                    <span>
						<el-icon><el-icon-eleme-filled /></el-icon>
					</span>
                    <span>
						<el-icon class="add"><el-icon-plus /></el-icon>
					</span>
                    <span>
                        <text style="font-size: 40px">W</text>
					</span>
                </div>
            </div>
            <div class="login_adv__mask"></div>
            <div class="login_adv__bottom">
                © {{Config.AppName}} {{Config.AppVersions}}
            </div>
        </div>
        <div class="login_main">
            <div class="login_config">
                <el-button :icon="dark?'el-icon-sunny':'el-icon-moon'" circle type="info" @click="configDark"></el-button>
            </div>
            <div class="login-form">
                <div class="login-header">
                    <div class="logo">
                        <img :alt="Config.AppName" src="@/assets/image/logo.png">
                        <label>{{Config.AppName}}</label>
                    </div>
                </div>
                <el-form :model="form" class="form-box" size="large" label-position="top">
                    <el-form-item prop="user" label="用户名">
                        <el-input v-model="form.username" prefix-icon="el-icon-user" clearable placeholder="请输入您的用户名">
                        </el-input>
                    </el-form-item>
                    <el-form-item prop="password" label="密码">
                        <el-input v-model="form.password" prefix-icon="el-icon-lock" clearable show-password placeholder="请输入您的密码"></el-input>
                    </el-form-item>
                    <el-form-item v-if="captchaSignin" label="验证码" class="captcha-input">
                        <el-input v-model="form.captcha" placeholder="请输入验证码">
                            <template #append>
                                <el-image :src="captcha" @click="getCaptcha"></el-image>
                            </template>
                        </el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" style="width: 100%;" round @click="submitForm">登 陆</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
    </div>
</template>

<script>
    import { getCurrentInstance, defineComponent, ref, reactive } from 'vue'
    import { useUserStore } from '@/store'
    import Api from '@/config/api'
    import md5 from 'md5'
    import Cache from '@/utils/cache'
    import Config from '@/config'

    export default defineComponent({
        components: {},
        setup() {
            const StoreUser = useUserStore()
            const form = reactive([])
            form.formname = 'login' + md5(Date.parse(new Date()) / 1000 + Config.AppKey)
            const { proxy } = getCurrentInstance()

            const captchaSignin = ref(false)
            proxy.jiu.request(Api.AdminLoginConfig).then((res, rej) => {
                captchaSignin.value = parseInt(res.data.captcha_signin)
            }).catch((error) => {
                proxy.jiu.showError(error)
            })

            const captcha = ref()
            const getCaptcha = () => {
                proxy.jiu.request(Api.AdminPublicsCaptcha, { 'codeid': 'login', 'formname': form.formname }).then((res, rej) => {
                    captcha.value = res.data.img
                }).catch((error) => {
                    proxy.jiu.showError(error)
                })
            }

            const submitForm = () => {
                proxy.jiu.request(Api.AdminPublicsLogin, form).then((res, rej) => {
                    StoreUser.login(res.data)
                    proxy.$router.push({ path: '/agency/index/index' })
                }).catch((error) => {
                    if(error.error === 20301){
                        getCaptcha()
                    }
                    proxy.jiu.showError(error)
                })
            }

            const dark = ref(Cache.get('APP_DARK') || false)

            const configDark = () => {
                dark.value = !dark.value
                if (dark.value) {
                    document.documentElement.classList.add('dark')
                    Cache.add('APP_DARK', dark.value)
                } else {
                    document.documentElement.classList.remove('dark')
                    Cache.del('APP_DARK')
                }
            }
            return {
                submitForm,
                getCaptcha,
                captcha,
                captchaSignin,
                form,
                Config,
                dark,
                configDark
            }
        },
        mounted() {
            this.$nextTick(function () {
                this.getCaptcha()
            })
        }
    })
</script>
